import React, { useContext, useState } from 'react';
import { LocalStorage } from 'src/common/helpers/local-storage';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';
import { RedirectContext, XLRStartSequenceState } from 'src/xlr-configuration/xlr-startup';
import { userLockStatus } from '../../common/enumerations/user-lock-status';
import { ILoginUser } from '../../common/interfaces/dtos/ILoginUser';
import { ILoginUserErrors } from '../../common/interfaces/dtos/ILoginUserErrors';
import { store } from '../../common/redux/configure-store';
import { MenuPanelActions } from '../../common/redux/reducers/menu-panel-reducer';
import { registerTouchpoint } from '../business-logic/register-touchpoint';
import { updateTouchPointConfiguration } from '../business-logic/touchpoint-configuration';
import UserLogin from './user-login/user-login';
export enum RegistrationErrors {
  MissingUserID = 'User ID is required.',
  MissingPassword = 'Pin Code is required',
  MissingTouchpointID = 'Touchpoint ID is required',
  MissingBusinessUnitID = 'Business Unit ID is required',
}

const TouchPointRegistration: React.FC = (): JSX.Element => {
  const [user, setLogin] = useState<ILoginUser>({});
  const [errors, setErrors] = useState<ILoginUserErrors>({});
  const { setStartupState } = useContext(RedirectContext);
  const { requiresUpdateTouchPoint } = getCurrentXLRConfig();

  const configuration = getCurrentXLRConfig();
  function handleCancel(): void {
    setLogin(
      (prevUser: ILoginUser): ILoginUser => ({
        ...prevUser,
        userName: '',
        password: '',
        touchPointId: '',
        businessUnitId: undefined,
      }),
    );
  }

  async function handleLogin(event: React.FormEvent<HTMLFormElement>): Promise<void> {
    event.preventDefault();
    errors.Description = '';

    setErrors(
      (prevErr: ILoginUserErrors): ILoginUserErrors => ({
        ...prevErr,
        Description: errors.Description,
      }),
    );

    if (user.touchPointId && (user.businessUnitId || !configuration.showBuID)) {
      if (requiresUpdateTouchPoint) {
        //We need implement register Touchpoint in BFF for SE.
        //In BFF \services\emerald-auth.service.ts Methods: loginAndRegisterTouchPoint and registerTouchPoint
        LocalStorage.setTillId(user.touchPointId);
        LocalStorage.setComputerName(user.touchPointId);
        await updateTouchPointConfiguration()
          .then(() => {
            setStartupState(XLRStartSequenceState.Initialize);
          })
          .catch((err): void => {
            errors.Description = err.message;
            setErrors(errors);
            handleCancel();
          });
      } else {
        if (user.userName && user.password) {
          await registerTouchpoint(
            user.userName,
            user.password,
            user.touchPointId,
            user.businessUnitId,
          )
            .then(() => {
              setStartupState(XLRStartSequenceState.Initialize);
            })
            .catch((err): void => {
              errors.Description = err.message;
              setErrors(errors);
              handleCancel();
            });
        }
      }
    }
  }

  return (
    <UserLogin
      showTpId={true}
      showBuId={configuration.showBuID}
      user={user}
      setUser={setLogin}
      errors={errors}
      setErrors={setErrors}
      handleIAMLogin={() => {}}
      onSubmit={handleLogin}
      lockStatus={userLockStatus.None}
      toggleWelcomeVisible={(): void => {
        store.dispatch(MenuPanelActions.toggle());
      }}
      alternateButton={{
        label: 'Cancel_Button',
        onClick: () => handleCancel(),
      }}
      submitButton={{
        label: 'Register_Button',
        onClick: () => {},
      }}
    />
  );
};

export default TouchPointRegistration;
